import { useReportMetricsContextV2 } from 'src/contexts/ReportMetricsContext/ReportMetricsContextV2';
import SaleLineItemReportTableV2 from 'src/tables/SaleLineItemReportTable/SaleLineItemReportTableV2';

import { ReportsPageLayout } from '../Reports/ReportsPageLayout';
import * as styles from './ReportsSaleLineItemPage.css';

export function ReportsSaleLineItemPage() {
  // All the child components treat tempReportConfig as the reportConfig
  // to get its latest state
  const {
    tempReportConfig: reportConfig,
    reportMetrics,
    reportSummary,
    reportValueTypes,
  } = useReportMetricsContextV2();

  return (
    <ReportsPageLayout
      reportConfig={reportConfig}
      reportTable={
        <SaleLineItemReportTableV2
          className={styles.table}
          metricsData={reportMetrics}
          summaryData={reportSummary}
          report={reportConfig}
          reportValueTypes={reportValueTypes}
        />
      }
    />
  );
}
